<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-兼职教练-修改
    -->
    <el-dialog
    title="修改兼职教练"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="60%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">修改兼职教练</div>
      
      <el-form-item label="类目" prop="jz_menu_id">
        <el-select v-model="form.jz_menu_id" placeholder="请选择类目" class="max-w460">
            <template v-for="jz in jzList">
              <el-option :value="jz.jz_menu_id" :key="jz.jz_menu_id" :label="jz.name"></el-option>
            </template>
        </el-select>
      </el-form-item>
      
      <el-form-item label="兼职教练名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入兼职教练名称" class="max-w460"></el-input>
      </el-form-item>
      
      <el-form-item label="公司名称" prop="nickname">
        <el-input v-model="form.nickname" placeholder="请输入公司名称" class="max-w460"></el-input>
      </el-form-item>
      
      <el-form-item label="价格" prop="price">
        <el-input v-model="form.price" placeholder="请输入价格" class="max-w460"></el-input>
      </el-form-item>

        <el-form-item label="薪资要求" prop="price">
        <el-input v-model="form.requirement" placeholder="请输入薪资要求" class="max-w460"></el-input>
      </el-form-item>

      <!-- 上传头像 -->
      <el-form-item label="图片" prop="avatar">
        <div class="image-upload-wrapper">
          <div class="image-preview" v-if="form.avatar">
            <img :src="form.avatar" class="preview-image" />
            <div class="image-actions">
              <i class="el-icon-delete" @click="deleteImage('avatar')"></i>
            </div>
          </div>
          <div class="upload-placeholder" @click="openImageUpload('avatar')" v-else>
            <i class="el-icon-plus"></i>
            <div>上传头像</div>
          </div>
        </div>
        <p class="tc gray9">建议尺寸200x200</p>
      </el-form-item>

      <!-- 上传封面图 -->
      <!-- <el-form-item label="封面图片" prop="cover_image">
        <div class="image-upload-wrapper">
          <div class="image-preview" v-if="form.cover_image">
            <img :src="form.cover_image" class="preview-image" />
            <div class="image-actions">
              <i class="el-icon-delete" @click="deleteImage('cover_image')"></i>
            </div>
          </div>
          <div class="upload-placeholder" @click="openImageUpload('cover_image')" v-else>
            <i class="el-icon-plus"></i>
            <div>上传封面</div>
          </div>
        </div>
        <p class="tc gray9">建议尺寸750x400</p>
      </el-form-item> -->

      <el-form-item label="介绍">
        <div class="edit_container">
          <Uediter v-model="form.intro" :text="ueditor.text" :config="ueditor.config" ref="ue"></Uediter>
        </div>
      </el-form-item>  

      <el-form-item label="排序" prop="sort">
        <el-input v-model="form.sort" placeholder="请输入排序" class="max-w460"></el-input>
      </el-form-item>
    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
    
    <!-- 图片上传组件 -->
    <Upload 
      v-if="isProductUpload" 
      :config="{ total: 1 }" 
      :isupload="isProductUpload" 
      @returnImgs="returnProductImgsFunc">
      上传图片
    </Upload>
  </div>
</el-dialog>
  
</template>

<script>
import Coach_coachApi from '@/api/coach_coach.js';
import Upload from '@/components/file/Upload';
import Uediter from '@/components/UE.vue';

export default {
  components: {
    Upload,
    Uediter
  },
  data() {
    return {
      /*是否上传图片*/
      isupload: false,
      isImg: false,  
      /*富文本配置*/
      ueditor: {
        text: '',
        config: {
          initialFrameWidth: 400,
          initialFrameHeight: 500
        }
      },
      /*form表单数据*/
      form: {
        jz_menu_id: '',
        nickname: '',
        price: '',
        name: '',
        code: 'custom',
        sort: 50,
        intro: "",
        avatar: '', // 教练头像
        cover_image: '', // 封面图片
        avatar_id: '', // 头像文件ID
        cover_image_id: '' // 封面文件ID
      },
      jzList: [],
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入兼职教练名称', trigger: 'blur' }],
        jz_menu_id: [{ required: true, message: '请选择类目', trigger: 'change' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }]
      },
      dialogVisible: false,
      isProductUpload: false,
      currentUploadField: '' // 当前上传的字段
    };
  },
  created() {
    this.dialogVisible = this.open_add;
    this.getJzList();
    this.getDetail();
  },
  props: ["open_add","coach_coach_id"],
  methods: {
    getJzList(){
      Coach_coachApi.getJzList().then(res => {
        this.jzList = res.data.data;
      });
    },

    /*打开图片上传*/
    openImageUpload(field) {
      this.currentUploadField = field;
      this.isProductUpload = true;
    },

    /*删除图片*/
    deleteImage(field) {
      this.form[field] = '';
      this.form[field + '_id'] = '';
    },

    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.$emit("close", {});
    },
    
    cancelFunc() {
      this.dialogFormVisible("error");
    },

    getDetail() {
      let self = this;
      Coach_coachApi.detail({coach_coach_id: self.coach_coach_id}, true).then(res => {
        self.form = res.data;
        self.ueditor.text = self.form.intro;
        self.isImg = true;
        self.loading = false;
        
        // 确保图片字段存在
        if (!self.form.avatar) self.form.avatar = '';
        if (!self.form.cover_image) self.form.cover_image = '';
        if (!self.form.avatar_id) self.form.avatar_id = '';
        if (!self.form.cover_image_id) self.form.cover_image_id = '';
      }).catch(error => {});
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      form.coach_coach_id = self.coach_coach_id;
      form.intro = this.$refs.ue.getUEContent();
      
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          Coach_coachApi.edit(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error");
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*上传图片*/
    returnProductImgsFunc(e) {
      if (e != null && e.length > 0) {
        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
        let prevent = false;
        
        e.forEach((element) => {
          let data_array = element.file_path.split(".");
          let ext = data_array[data_array.length - 1].toLowerCase();
          imgExpt.forEach((imgExt) => {
            if (imgExt === ext) {
              prevent = true;
              return false;
            }
          });
        });

        if (!prevent) {
          this.$message.error("图片类型有误,请选择正确的图片格式");
          return false;
        }

        // 根据当前上传的字段设置对应的数据
        if (this.currentUploadField === 'avatar') {
          this.form.avatar_id = e[0].file_id;
          this.form.avatar = e[0].file_path;
        } else if (this.currentUploadField === 'cover_image') {
          this.form.cover_image_id = e[0].file_id;
          this.form.cover_image = e[0].file_path;
        }
      }
      
      this.isProductUpload = false;
      this.currentUploadField = '';
    }
  }
};
</script>

<style scoped>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}

/* 图片上传样式 */
.image-upload-wrapper {
  display: flex;
  flex-wrap: wrap;
}

.image-preview {
  position: relative;
  width: 100px;
  height: 100px;
  margin-right: 10px;
  border: 1px solid #ddd;
  border-radius: 8px;
  overflow: hidden;
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.image-actions {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 4px;
  cursor: pointer;
  display: none;
}

.image-preview:hover .image-actions {
  display: block;
}

.upload-placeholder {
  width: 100px;
  height: 100px;
  border: 1px dashed #ddd;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  color: #999;
}

.upload-placeholder:hover {
  border-color: #409eff;
  color: #409eff;
}

.upload-placeholder i {
  font-size: 24px;
  margin-bottom: 8px;
}

.tc {
  text-align: center;
}

.gray9 {
  color: #999;
  font-size: 12px;
  margin-top: 5px;
}

.max-w460 {
  max-width: 460px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/coach_coach/index/part/edit.vue